<template>
  <li
    v-if="showSearchCard"
    class="search__item mb-3"
    style="cursor: pointer;"
    @click="onClickCard">
    <div class="search__heading p-2 mb-4">
      <div class="search__lead mb-1">
        目標
      </div>
      <div class="d-flex align-items-center">
        <span
          v-if="goal.isLocked"
          class="material-icons goal-lock-icon">
          lock
        </span>
        <span>
          {{ goal.name }}
        </span>
      </div>
    </div>
    <div
      v-if="activityItems.length > 0"
      @click.stop>
      <search-card-activity-panel
        v-for="activity in activityItems"
        :key="activity.id"
        :goal="goal"
        :activity="activity" />
    </div>
    <div
      v-else
      class="p-2">
      この目標に活動はまだありません
    </div>
  </li>
</template>

<script>
import SearchCardActivityPanel from '@/components/view/SearchCardActivityPanel'
export default {
  components: {
    SearchCardActivityPanel
  },
  props: {
    goal: {
      type: Object,
      default: null
    },
    searchKeyword: {
      type: String,
      default: null
    },
    lockGoalOption: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    activities() {
      if (!this.goal) return []
      return this.goal.activityResults.slice()
    },
    filteredActivities() {
      const arr = this.activities.filter(v => {
        return v.name.includes(this.searchKeyword) || v.detail.includes(this.searchKeyword)
      })
      return arr
    },
    activityItems() {
      if (this.goal.name.includes(this.searchKeyword)) return this.activities
      return this.filteredActivities
    },
    // 鍵付きオプションがoffの時に鍵付き目標は表示しない
    showSearchCard() {
      if (!this.goal) return false
      if (!this.lockGoalOption && this.goal.isLocked) return false
      return true
    }
  },
  methods: {
    onClickCard() {
      const decoded = decodeURIComponent(`/members/${this.goal.createdBy.id}?goalId=${this.goal.id}&goalEndDate=${this.goal.endDate}`)
      this.$router.push(decoded)
    }
  }
}
</script>

<style lang="scss" scoped>
.search{
  &__item{
    background-color: $white;
    border-radius: 4px;
  }
  &__heading{
    font-weight: bold;
    border-bottom: solid 1px $grey10;
  }
  &__lead{
    font-size: $fs-s;
    color: $grey08;
    display: block;
    font-weight: normal;
  }
}
</style>